import { render } from "./ReturnPolicy_VDay.vue?vue&type=template&id=fba7b8de"
import script from "./ReturnPolicy_VDay.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy_VDay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__